// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verticalLayout-module_verticalLayout__O7rYb {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

.verticalLayout-module_verticalLayout__O7rYb > div {
    flex: 1;
}

.verticalLayout-module_verticalLayoutWide__xqSN7 {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;

    @media screen and (min-width: 481px) {
        max-width: 480px;
    }
    @media screen and (min-width: 708px) {
        max-width: 100%;
    }
    @media screen and (min-width: 889px) {
        max-width: 888px;
    }
}

.verticalLayout-module_verticalLayoutWide__xqSN7 > div {
    flex: 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/layout/css/verticalLayout.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,cAAc;IACd,WAAW;IACX,sBAAsB;;IAEtB;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,OAAO;AACX","sourcesContent":[".verticalLayout {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.verticalLayout > div {\n    flex: 1;\n}\n\n.verticalLayoutWide {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n\n    @media screen and (min-width: 481px) {\n        max-width: 480px;\n    }\n    @media screen and (min-width: 708px) {\n        max-width: 100%;\n    }\n    @media screen and (min-width: 889px) {\n        max-width: 888px;\n    }\n}\n\n.verticalLayoutWide > div {\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"verticalLayout": `verticalLayout-module_verticalLayout__O7rYb`,
	"verticalLayoutWide": `verticalLayout-module_verticalLayoutWide__xqSN7`
};
export default ___CSS_LOADER_EXPORT___;
